export const IS_INSTANT_PLAYER_MUTE = 'is_instant_player_mute'
